module.exports = __webpack_public_path__ + "img/SMT_03_Mr_Chern_Siang_Jye.fc96b2ca.jpg";